import type { ReactElement, ReactNode } from 'react'

import { Icon } from '../icon/icon.tsx'
import type { IconName } from '../icon/icon-paths.ts'

/** Maps to the verified chip token pairs — every one clears 7:1 on its own ground. */
export type ChipTone = 'bird' | 'leaf' | 'warm' | 'mem' | 'neutral'

export interface ChipProps {
  readonly tone: ChipTone
  readonly icon?: IconName
  readonly children: ReactNode
}

/**
 * A label, not a control.
 *
 * Non-interactive by construction: a `<span>`, with no `href` and no `onClick`
 * available to pass. The design's chips describe things ("Natureza", "Pássaros");
 * making them look pressable would promise a navigation that does not exist.
 *
 * `tone` resolves to a modifier class. It never becomes an inline style — the
 * design set `background` and `color` directly on the element, which
 * `style-src 'self'` blocks.
 */
export function Chip({ tone, icon, children }: ChipProps): ReactElement {
  return (
    <span className={`chip chip--${tone}`}>
      {icon === undefined ? null : <Icon name={icon} size={17} decorative />}
      <span className="chip__label">{children}</span>
    </span>
  )
}
